import { render, staticRenderFns } from "./addStaff.vue?vue&type=template&id=dce4a2ba&scoped=true"
import script from "./addStaff.vue?vue&type=script&lang=js"
export * from "./addStaff.vue?vue&type=script&lang=js"
import style0 from "./addStaff.vue?vue&type=style&index=0&id=dce4a2ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce4a2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce4a2ba')) {
      api.createRecord('dce4a2ba', component.options)
    } else {
      api.reload('dce4a2ba', component.options)
    }
    module.hot.accept("./addStaff.vue?vue&type=template&id=dce4a2ba&scoped=true", function () {
      api.rerender('dce4a2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/staffManagement/roster/addStaff.vue"
export default component.exports